import { useState, type FC } from 'react';

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';

export const ItemIconWithToolTip: FC<{
  tooltipContent: string;
  children: React.ReactNode;
}> = ({ tooltipContent, children }) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Tooltip onOpenChange={setOpen} open={open} modal>
      <TooltipTrigger
        asChild
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {children}
      </TooltipTrigger>
      <TooltipPortal>
        {tooltipContent && (
          <TooltipContent className="max-w-48 overflow-auto break-words">
            {tooltipContent}
            <TooltipArrow />
          </TooltipContent>
        )}
      </TooltipPortal>
    </Tooltip>
  );
};
